import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import PitBox from './pitBox';
import BookBox from './bookBox';

class PBNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { pitData, bookData, homeAndBookAd0, homeAndBookAd1, homeAndBookAd2 },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className="clearfix">
                    <PitBox content={pitData} />
                    <BookBox content={bookData} />
                </div>
                <div className={styles.ad_box}>
                    <NoSSR>
                        <Ad content={homeAndBookAd0} styleName={styles.fl} />
                    </NoSSR>
                    <NoSSR>
                        <Ad content={homeAndBookAd1} styleName={styles.fr} />
                    </NoSSR>
                </div>
                {homeAndBookAd2 ? <Ad content={homeAndBookAd2} styleName={styles.ad} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(PBNews);
